import React, { Component } from 'react';
import styles from './styles.module.scss';
import PopupContainer from '../../../../components/PopupContainer';
import Popup from '../../../../components/SimplePopup';
import { withRouter } from 'react-router-dom';

import {
  loginImages,
  commonImages,
  operatorImages,
} from '../../../../assets/images';
import moment from 'moment';
import ViewRenderer from './views';
import { API } from '../../../../requests';
import strings from '../../../../globalization';
import Spinner from '../../../../components/Spinner';
import DownloadPendingPopup from '../../../../components/DownloadPendingPopup';
import util from '../../../../util';
import * as XLSX from 'xlsx';
import {
  DATE_SELECTION_MODES,
  PERIOD_SELECTION_TYPES,
  getFullYearDateRange,
  getTodayRange,
  validateDateRange,
  validateTimeRange,
  toStoredDates,
} from './dateUtils';

const POPUP_CONSTANTS = {
  STANDARD: 'standard',
  ERROR: 'error',
  SPINNER_POPUP: 'spinner-popup',
  SIMPLE_POPUP: 'simple-popup',
  DOWNLOAD_PENDING: 'download-pending',
};

const DOWNLOAD_TIMEOUT_MS = 3000;
const DOWNLOAD_PENDING_MESSAGE =
  'The report generation process has been initiated. Please visit the Generated Reports section in a few minutes to download your report.';
class VehicleEntryExitMovement extends Component {
  constructor(props) {
    super(props);
    console.log('this.props.type:', this.props.type);
    this.state = {
      permits: [],
      downloadedList: [],
      CSVLoading: false,
      totalCount: 0,
      selectedType: 'entry',
      selectedStatus: this.props.type,
      selectedDropDownStatus: {
        id: '1',
        name: 'entry',
        displayName: 'ENTRY',
      },
      dateSelectionMode: DATE_SELECTION_MODES.TODAY,
      selectedYear: moment().year(),
      periodSelectionType: PERIOD_SELECTION_TYPES.YEAR,
      dateValidationError: null,
      ...getTodayRange(),
      startTime: moment().startOf('day'),
      endTime: moment().endOf('day'),

      searchText: '',
      perPage: 100,
      statuses: [
        {
          id: '1',
          name: 'entry',
          displayName: 'ENTRY',
        },
        {
          id: '2',
          name: 'exit',
          displayName: 'EXIT',
        },
      ],
    };

    // setTimeout(() => {
    //   const {statuses, selectedType} = this.state;
    //   this.onChangeHandler(
    //     'statusChange',
    //     statuses.filter(option => option?.name === selectedType)[0],
    //   );
    // }, 0);
  }

  fetchAgencyReportSummary = (paramsList, status) => {
    const {dateSelectionMode} = this.state;
    const isToday = dateSelectionMode === DATE_SELECTION_MODES.TODAY;

    if (status === 'vehicle') {
      return isToday
        ? API.fetchAgencyReportsForVehiclesToday(paramsList)
        : API.fetchAgencyReportsForVehicles(paramsList);
    }

    return isToday
      ? API.fetchAgencyReportsForVehicleEntryAndExitToday(paramsList)
      : API.fetchAgencyReportsForVehicleEntryAndExit(paramsList);
  };

  getData = async (
    params,
    startDate,
    endDate,
    status,
    page,
    perPage,
    searchString,
    startTime,
    endTime,
    selectedType,
    dateSelectionMode,
    periodSelectionType,
  ) => {
    const validationError = validateDateRange(
      startDate,
      endDate,
      dateSelectionMode,
      periodSelectionType,
    );
    if (validationError) {
      params.successCallback([], 0);
      this.setState({
        popup: undefined,
        permitList: [],
        totalCount: 0,
        dateValidationError: validationError,
      });
      return;
    }
    console.log('status:', status, searchString);
    this.setState({
      popup: {
        type: POPUP_CONSTANTS.SPINNER_POPUP,
      },
    });
    console.log(startDate, endDate);
    let paramsList = {
      startDate: `${moment(startDate, 'MM-DD-YYYY').format(
        'DD-MM-YYYY',
      )} ${moment(startTime).format('HH:mm')}`,
      endDate: `${moment(endDate, 'MM-DD-YYYY').format('DD-MM-YYYY')} ${moment(
        endTime,
      ).format('HH:mm')}`,
      //      status: status,
      // accessType: selectedType === 'entry' ? 0 : 1,
      searchString,
      pageNumber: page,
      pageSize: perPage,
    };

    if (status === 'vehicle') {
      await this.fetchAgencyReportSummary(paramsList, status)
        .then(resp => resp)
        .then(res => {
          console.log('response:', res.data, perPage);
          params.successCallback(
            res?.data.vehicleMovementArray,
            res?.data?.totalCount ? res?.data?.totalCount : 0,
          );
          this.setState({
            popup: undefined,
            permitList: res?.data?.vehicleMovementArray,
            totalCount: res?.data?.totalCount,
          });
        })
        .catch(err => {
          console.log(err);
          params.successCallback([], 0);
          this.setState({
            popup: undefined,
          });
        });

    } else {
      await this.fetchAgencyReportSummary(paramsList, status)
        .then(resp => resp)
        .then(res => {
          console.log('response:', res.data, perPage);
          params.successCallback(
            res?.data.vehicleEntryExit,
            res?.data?.totalCount ? res?.data?.totalCount : 0,
          );
          this.setState({
            popup: undefined,
            permitList: res?.data?.vehicleEntryExit,
            totalCount: res?.data?.totalCount,
          });
        })
        .catch(err => {
          console.log(err);
          params.successCallback([], 0);
          this.setState({
            popup: undefined,
          });
          const error = util.getErrorMessage(err);
          this.showErrorPopup(error);

        });

    }

  };

  componentDidMount() {
    this.onChangeHandler('updateTable');
  }
  getErrorMessage = referenceId => {
    return (
      <div className={styles.requestSuccess}>
        <div>
          <img
            src={commonImages.errorIcon}
            className={styles.successIcon}
            alt="logo"
          />
        </div>
        <div className={styles.errorMsg}>
          {strings.ADMIN.POP_UP.errorMessage}
        </div>
      </div>
    );
  };

  getSuccessMessage = referenceId => {
    return (
      <div className={styles.requestSuccess}>
        <div>
          <img
            src={loginImages.successIcon}
            className={styles.successIcon}
            alt="logo"
          />
        </div>
        <div className={styles.successMessage}>
          {strings.ADMIN.POP_UP.approveCnf1} {referenceId}
          {strings.ADMIN.POP_UP.approveCnf2}
        </div>
      </div>
    );
  };

  onChangeHandler = (action, data) => {
    console.log(data, action);
    switch (action) {
      case 'statusChange': {
        console.log(data);
        if (data) {
          this.setState({
            selectedType: data?.name,
            selectedDropDownStatus: data,
          });
        }
        break;
      }

      case 'dateMode': {
        if (data === DATE_SELECTION_MODES.TODAY) {
          this.setState({
            dateSelectionMode: DATE_SELECTION_MODES.TODAY,
            dateValidationError: null,
            ...getTodayRange(),
          });
        } else {
          const year = moment().year();
          const yearRange = getFullYearDateRange(year);
          this.setState({
            dateSelectionMode: DATE_SELECTION_MODES.HISTORICAL,
            periodSelectionType: PERIOD_SELECTION_TYPES.YEAR,
            selectedYear: year,
            dateValidationError: null,
            startDate: yearRange.startDate,
            endDate: yearRange.endDate,
            dates: yearRange.dates,
          });
        }
        break;
      }

      case 'date': {
        const { startDate, endDate, dates } = data;
        const { dateSelectionMode, periodSelectionType } = this.state;
        const validationError = validateDateRange(
          startDate,
          endDate,
          dateSelectionMode,
          periodSelectionType,
        );
        if (validationError) {
          this.setState({ dateValidationError: validationError });
          this.showErrorPopup(validationError);
          return;
        }
        this.setState({
          startDate,
          endDate,
          dates,
          dateValidationError: null,
        });
        break;
      }

      case 'applyDateSelection': {
        const {
          dateSelectionMode,
          startDate,
          endDate,
          dates,
          selectedYear,
          periodSelectionType,
          startTime,
          endTime,
        } = data;
        const storedDates = toStoredDates(dates, startDate, endDate);
        const dateValidationError = validateDateRange(
          storedDates.start,
          storedDates.end,
          dateSelectionMode,
          periodSelectionType,
        );
        if (dateValidationError) {
          this.setState({ dateValidationError });
          return;
        }
        const timeValidationError = validateTimeRange(
          storedDates.start,
          storedDates.end,
          startTime,
          endTime,
        );
        if (timeValidationError) {
          this.setState({ dateValidationError: timeValidationError });
          return;
        }
        this.setState(
          {
            dateSelectionMode,
            startDate: storedDates.start,
            endDate: storedDates.end,
            dates: storedDates,
            selectedYear,
            periodSelectionType,
            startTime,
            endTime,
            dateValidationError: null,
          },
          () => this.onChangeHandler('updateTable'),
        );
        break;
      }

      case 'search': {
        console.info('data..', data);
        this.setState({
          searchText: data,
        });
        break;
      }
      case 'gridAPI': {
        console.log('grid API', data);
        this.setState({ gridApi: data });
        this.onChangeHandler('updateTable');
        break;
      }
      case 'updateTable': {
        const {
          gridApi,
          selectedStatus,
          startDate,
          endDate,
          searchText,
          perPage,
          startTime,
          endTime,
          selectedType,
          dateSelectionMode,
          periodSelectionType,
        } = this.state;
        this.setState({ downloadedList: [] });
        if (gridApi) {
          const dataSource = {
            getRows: params => {
              const page = params.endRow / perPage;
              console.log(page, params, selectedStatus);
              this.getData(
                params,
                startDate,
                endDate,
                selectedStatus,
                page - 1,
                perPage,
                searchText,
                startTime,
                endTime,
                selectedType,
                dateSelectionMode,
                periodSelectionType,
              );
            },
          };
          gridApi.setDatasource(dataSource);
        }
        break;
      }
      case 'startTime': {
        this.setState({
          startTime: data,
        });
        break;
      }
      case 'endTime': {
        this.setState({
          endTime: data,
        });
        break;
      }
      default: {
        console.info('case not handled', action);
      }
    }
  };

  /**
   *
   * @param {*} action
   * @param {*} data
   */

  onClickHandler = (action, data) => {
    const { history, location, status } = this.props;
    console.log('action...', action, 'data...', data);
    switch (action) {
      case 'signin': {
        history.push('/sign-in');
        break;
      }
      case 'vehicle-registration': {
        history.push('/vehicle-registration');
        break;
      }
      case 'apply': {
        const {
          startDate,
          endDate,
          dateSelectionMode,
          periodSelectionType,
          startTime,
          endTime,
        } = this.state;
        const dateValidationError = validateDateRange(
          startDate,
          endDate,
          dateSelectionMode,
          periodSelectionType,
        );
        if (dateValidationError) {
          this.setState({ dateValidationError });
          this.showErrorPopup(dateValidationError);
          return;
        }
        const timeValidationError = validateTimeRange(
          startDate,
          endDate,
          startTime,
          endTime,
        );
        if (timeValidationError) {
          this.setState({ dateValidationError: timeValidationError });
          this.showErrorPopup(timeValidationError);
          return;
        }
        this.setState({ dateValidationError: null });
        this.onChangeHandler('updateTable');
        break;
      }
      case 'clearFilters': {
        this.resetData();
        break;
      }

      case 'statusRoute': {
        //FIXME
        history.push({
          pathname: '/u/reports/' + data.route,
        });

        break;
      }
      case 'document-view': {
        history.push({
          pathname: location.pathname + '/document-view',
          state: { background: location, url: data },
        });
        break;
      }

      case 'loadCSV': {
        this.getCSVData();
        break;
      }

      default: {
        console.info('case not handled', action);
      }
    }
  };

  showSpinner = () => {
    this.setState({
      popup: {
        type: POPUP_CONSTANTS.SPINNER_POPUP,
      },
    });
  };

  showDownloadPendingPopup = () => {
    this.setState({
      popup: {
        type: POPUP_CONSTANTS.DOWNLOAD_PENDING,
      },
    });
  };

  goToGeneratedReports = () => {
    this.closePopup();
    this.props.history.push('/u/reports/generated');
  };

  showSuccessPopup = successMessage => {
    this.setState({
      popup: {
        type: POPUP_CONSTANTS.SIMPLE_POPUP,
        message: successMessage,
        onClose: this.closePopup,
        headingImage: operatorImages.successIcon,
        buttons: [
          {
            text: strings.okayPopup,
            onClick: this.closePopup,
            outline: true,
          },
        ],
      },
    });
  };

  showErrorPopup = errorMessage => {
    this.setState({
      popup: {
        type: POPUP_CONSTANTS.SIMPLE_POPUP,
        message: errorMessage,
        messageStyle: { color: '#E67717' },
        headingImage: commonImages.errorIcon,
        onClose: this.closePopup,
        buttons: [
          {
            text: strings.okayPopup,
            onClick: this.closePopup,
            outline: true,
          },
        ],
      },
    });
  };

  resetData = () => {
    const { status } = this.props;
    this.setState({
      searchText: '',
      dateSelectionMode: DATE_SELECTION_MODES.TODAY,
      selectedYear: moment().year(),
      periodSelectionType: PERIOD_SELECTION_TYPES.YEAR,
      dateValidationError: null,
      ...getTodayRange(),
      startTime: moment().startOf('day'),
      endTime: moment().endOf('day'),
      selectedType: 'entry',
      selectedStatus: this.props.type,
      selectedDropDownStatus: {
        id: '1',
        name: 'entry',
        displayName: 'ENTRY',
      },
    });

    this.onChangeHandler('updateTable');
  };

  downloadExcel = data => {
    const updatedData = data.map(item => {
      console.log(item);
      return {
        Timestamp: moment(item.createdDate).format('DD/MM/YYYY HH:mm'),
        'Permit reference ID': item?.permitReferenceId,
        'Vehicle Registration Number': item?.vehicleRegistrationNumber,
        'Vehicle Owner Name': item?.vehicleOwnerName,
        Gate: item?.gateName,
        Credits: item?.credits,
        'Reconciliation Status': item?.reconciliationStatus,
      };
    });
    console.log(updatedData);
    const sheetNamePrefix = data[0]?.requestType;
    const worksheet = XLSX.utils.json_to_sheet(updatedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
    XLSX.writeFile(
      workbook,
      `${sheetNamePrefix} vehicle movement report-${moment().format(
        `DD-MM-YYYY`,
      )}.xlsx`,
    );
  };
  downloadPersonExcel = data => {
    const updatedData = data.map(item => {
      console.log(item);

      return {
        'Permit reference ID (Entry)': item.entryPermitRefId,
        'Permit reference ID (Exit)': item.exitPermitRefId,
        'Vehicle Registration Number': item.vehicleRegistrationNumber,
        'Vehicle Owner Name': item.ownerName,
        'Entry Agency': item.entryAgency,
        'Entry Gate': item.entryGateName,
        'Entry Timestamp': moment(item.entryDate).format('DD/MM/YYYY HH:mm'),
        'Exit Agency': item.exitAgency,
        'Exit Gate': item.exitGateName,
        'Exit Timestamp': moment(item.exitDate).format('DD/MM/YYYY HH:mm'),
        Credits: item?.credits,
        'Reconciliation Status': item?.reconciliationStatus,
      };
    });
    console.log(updatedData);
    // const sheetNamePrefix = data[0]?.requestType;
    const worksheet = XLSX.utils.json_to_sheet(updatedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
    XLSX.writeFile(
      workbook,
      `vehicle entry and exit report-${moment().format(
        `DD-MM-YYYY`,
      )}.xlsx`,
    );
  };

  hasDownloadExtension = fileName =>
    /\.(xlsx|zip)$/i.test(fileName || '');

  getDownloadFileName = downloadUrl => {
    const defaultFileName = `vehicle entry and exit report-${moment().format(
      'DD-MM-YYYY',
    )}.xlsx`;
    const urlFileName = downloadUrl.split('?')[0].split('/').pop();
    return this.hasDownloadExtension(urlFileName)
      ? urlFileName
      : defaultFileName;
  };

  getDownloadMimeType = fileName => {
    if (/\.zip$/i.test(fileName)) {
      return 'application/zip';
    }
    return 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
  };

  downloadFileFromUrl = async downloadUrl => {
    if (!downloadUrl) {
      return;
    }

    const fileName = this.getDownloadFileName(downloadUrl);
    const fallbackMimeType = this.getDownloadMimeType(fileName);

    const response = await fetch(downloadUrl);
    if (!response.ok) {
      throw new Error('Failed to download report file.');
    }

    const blob = await response.blob();
    const fileBlob =
      blob.type && blob.type !== 'application/octet-stream'
        ? blob
        : new Blob([blob], {type: fallbackMimeType});
    const objectUrl = window.URL.createObjectURL(fileBlob);

    const anchor = document.createElement('a');
    anchor.href = objectUrl;
    anchor.download = fileName;
    anchor.style.display = 'none';
    document.body.appendChild(anchor);
    anchor.click();
    anchor.remove();

    window.setTimeout(() => {
      window.URL.revokeObjectURL(objectUrl);
    }, 1000);
  };

  pollReportDownload = jobUuid => {
    let isFinished = false;
    let pollInterval;

    const stopPolling = () => {
      if (pollInterval) {
        clearInterval(pollInterval);
      }
    };

    const timeoutId = window.setTimeout(() => {
      if (isFinished) {
        return;
      }
      isFinished = true;
      stopPolling();
      this.setState({
        popup: undefined,
        downloadStatus: 'PENDING',
        jobUuid,
        CSVLoading: false,
      });
      this.showDownloadPendingPopup();
    }, DOWNLOAD_TIMEOUT_MS);

    pollInterval = setInterval(() => {
      API.fetchReportsDownloads(jobUuid)
        .then(res => {
          if (res?.data?.status === 'COMPLETED') {
            if (isFinished) {
              return;
            }
            isFinished = true;
            stopPolling();
            window.clearTimeout(timeoutId);
            const downloadUrl = res?.data?.downloadUrl;
            this.setState({
              downloadUrl,
              downloadStatus: 'COMPLETED',
              jobUuid: res?.data?.jobUuid,
              CSVLoading: true,
            });
            this.downloadFileFromUrl(downloadUrl)
              .then(() => {
                this.setState({
                  popup: undefined,
                  CSVLoading: false,
                });
              })
              .catch(err => {
                console.log('download failed:', err);
                this.setState({popup: undefined, CSVLoading: false});
                this.showErrorPopup(
                  util.getErrorMessage(err) ||
                    'Failed to download report. Please try again.',
                );
              });
          }
          if (res?.data?.status === 'FAILED') {
            if (isFinished) {
              return;
            }
            isFinished = true;
            stopPolling();
            window.clearTimeout(timeoutId);
            this.setState({
              popup: undefined,
              downloadStatus: 'FAILED',
              jobUuid: res?.data?.jobUuid,
              CSVLoading: false,
            });
            this.showErrorPopup('There was an error while downloading the report, Please try again after sometime.');
          }
        })
        .catch(err => {
          if (isFinished) {
            return;
          }
          isFinished = true;
          console.log('err', err);
          stopPolling();
          window.clearTimeout(timeoutId);
          this.setState({
            popup: undefined,
            downloadStatus: 'FAILED',
            jobUuid,
            CSVLoading: false,
          });
          this.showErrorPopup(util.getErrorMessage(err));
        });
    }, 1000);
  };

  getCSVData = async () => {
    this.showSpinner();
    const {
      startDate,
      endDate,
      startTime,
      endTime,
      selectedStatus,
      searchText,
      totalCount,
      selectedType,
    } = this.state;
    this.setState({ CSVLoading: false, downloadedList: [] });
    if (!startTime || !endTime || !startDate || !endDate) {
      this.showErrorPopup(`Date and Time parameters cannot be empty!`);
      return;
    }
    const { dateSelectionMode, periodSelectionType } = this.state;
    const validationError = validateDateRange(
      startDate,
      endDate,
      dateSelectionMode,
      periodSelectionType,
    );
    if (validationError) {
      this.showErrorPopup(validationError);
      this.setState({ popup: undefined, dateValidationError: validationError });
      return;
    }
    console.log(startDate, endDate);
    let params = {
      startDate: `${moment(startDate, 'MM-DD-YYYY').format(
        'DD-MM-YYYY',
      )} ${moment(startTime).format('HH:mm')}`,
      endDate: `${moment(endDate, 'MM-DD-YYYY').format('DD-MM-YYYY')} ${moment(
        endTime,
      ).format('HH:mm')}`,
      //      status: selectedStatus,
      //     accessType: selectedType === 'entry' ? 0 : 1,
      searchString: searchText,
      pageNumber: 0,
      pageSize: totalCount + 100,
    };
    console.log('params...', params, selectedStatus);
    if (selectedStatus === 'vehicle') {
      API.fetchAgencyReportsForVehicles(params)
        .then(res => {
          console.log('response:', res);

          this.setState({
            downloadedList: res?.data?.vehicleMovementArray,
            popup: undefined,
            totalCount: res?.data?.totalCount,
            CSVLoading: true,
          });

          const data = this.getCSVDownloadData();
          console.log('about to download:', data);
          this.downloadExcel(data);
        })
        .catch(err => {
          console.log('err', err);
          console.log(err);
          const error = util.getErrorMessage(err);
          this.showErrorPopup(error);
          this.setState({ CSVLoading: false });
        });
    } else {
      API.fetchAgencyReportsForVehicleEntryAndExitDownload(params)
        .then(res => {
          console.log('response:', res);
          const jobUuid = res?.data?.jobUuid;
          if (!jobUuid) {
            this.setState({popup: undefined, CSVLoading: false});
            this.showErrorPopup(
              'Failed to start report download. Please try again.',
            );
            return;
          }
          this.pollReportDownload(jobUuid);
        })
        .catch(err => {
          console.log('err', err);
          console.log(err);
          const error = util.getErrorMessage(err);
          this.showErrorPopup(error);
          this.setState({ CSVLoading: false });
        });
    }

  };

  getCSVDownloadData = () => {
    const { downloadedList } = this.state;

    console.log('downloadedList:', downloadedList);
    return downloadedList.map(el => {
      const vehicleRegistrationNumber = el?.vehicleRegistrationNumber
        ? el?.vehicleRegistrationNumber
        : '-';
      const vehicleOwnerName = el?.vehicleOwnerName
        ? el?.vehicleOwnerName
        : '-';
      const numberOfPasses = el?.numberOfPasses ? el?.numberOfPasses : '-';
      return {
        requestType: el.requestType === 0 ? 'Entry' : 'Exit',
        createdDate: el.createdDate,
        permitReferenceId: el.permitReferenceId,
        vehicleRegistrationNumber: vehicleRegistrationNumber,
        vehicleOwnerName: vehicleOwnerName,
        gateName: el.gateName,
        credits: numberOfPasses,
        reconciliationStatus: el?.reconciliationStatus?.replace(/_/g, ' '),
      };
    });
  };

  getPersonCSVDownloadData = () => {
    const { downloadedList } = this.state;

    console.log('downloadedList:', downloadedList);
    return downloadedList.map(el => {
      // const personRFID = el?.personRFID
      //   ? el?.personRFID
      //   : '-';
      // const personName = el?.name
      //   ? el?.name
      //   : '-';
      const numberOfPasses = el?.numberOfPasses ? el?.numberOfPasses : '-';
      return {
        entryPermitRefId: el.entryPermitRefId,
        exitPermitRefId: el.exitPermitRefId,
        vehicleRegistrationNumber: el.vehicleRegistrationNumber,
        ownerName: el.ownerName,
        entryAgency: el.entryAgency,
        entryGateName: el.entryGateName,
        entryDate: el.entryDate,
        exitAgency: el.exitAgency,
        exitGateName: el.exitGateName,
        exitDate: el.exitDate,
        credits: numberOfPasses,
        reconciliationStatus: el?.reconciliationStatus?.replace(/_/g, ' '),
      };
    });
  };

  getProps = () => {
    const {
      statuses,
      permitList,
      searchText,
      selectedStatus,
      selectedType,
      startDate,
      endDate,
      dates,
      perPage,
      selectedDropDownStatus,
      CSVLoading,
      downloadedList,
      startTime,
      endTime,
      totalCount,
      dateSelectionMode,
      selectedYear,
      periodSelectionType,
      dateValidationError,
    } = this.state;
    return {
      onClick: this.onClickHandler,
      onChange: this.onChangeHandler,
      statuses,
      searchText,
      selectedDropDownStatus,
      selectedStatus,
      selectedType,
      startDate,
      endDate,
      dates,
      perPage,
      permitList: permitList,
      downloadedList,
      downloadData: this.getCSVDownloadData(),
      CSVLoading,
      startTime,
      endTime,
      totalCount,
      dateSelectionMode,
      selectedYear,
      periodSelectionType,
      dateValidationError,
    };
  };

  closePopup = () => {
    this.setState({
      popup: undefined,
    });
  };
  /**
   * @return {JSX.Element}
   */
  getPopupContent = () => {
    const { popup } = this.state;
    if (!popup) return;
    switch (popup.type) {
      case POPUP_CONSTANTS.SIMPLE_POPUP: {
        return <Popup {...popup} />;
      }

      case POPUP_CONSTANTS.SPINNER_POPUP: {
        return <Spinner name="cube-grid" color="#0045E6" {...popup} />;
      }
      case POPUP_CONSTANTS.DOWNLOAD_PENDING: {
        return (
          <DownloadPendingPopup
            message={DOWNLOAD_PENDING_MESSAGE}
            onClose={this.closePopup}
            onViewReports={this.goToGeneratedReports}
          />
        );
      }
      default: {
        console.warn('getPopupContent', popup.type);
        return null;
      }
    }
  };

  /**
   * @return {JSX.Element}
   */
  render() {
    const viewProps = this.getProps();
    const { popup } = this.state;
    return (
      <>
        {popup ? (
          <PopupContainer> {this.getPopupContent()} </PopupContainer>
        ) : null}
        <ViewRenderer {...viewProps} />
      </>
    );
  }
}

export default withRouter(VehicleEntryExitMovement);
